export type ContentFormats = "html" | "mobiledoc" | "plaintext" | "lexical";
export const contentFormats = ["html", "mobiledoc", "plaintext", "lexical"];
